<template>
    <ul v-if="category">
        <li
            v-for="({ name, product_count, url, children }, index) in category"
            :key="index"
            :class="{
                'has-children': children && children.length,
                'is-open': childrenOpen === index
            }"
        >
            <a :href="url">
                <span class="link">{{ name }} ({{ product_count }})</span>
                <span
                    class="icon icon-arrow-indicators"
                    @click.prevent.stop="
                        childrenOpen = childrenOpen === index ? null : index
                    "
                >
                </span>
            </a>
            <CategoryTreeList
                v-if="children"
                v-show="childrenOpen === index"
                :category="children"
            />
        </li>
    </ul>
</template>

<script>
export default {
    name: 'CategoryTreeList',
    components: {},
    props: {
        category: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            childrenOpen: false
        }
    }
}
</script>
<style scoped lang="scss">
li {
    padding-right: 0;

    &.has-children {
        > a {
            padding-right: 4rem;

            .icon {
                display: flex;
            }
        }
    }

    &.is-open {
        > a {
            background: $sherpa-blue;
            color: $component-active-color;

            .icon {
                transform: rotate(90deg);
                filter: brightness(0) invert(1);
            }
        }

        li > a {
            padding-left: 30px;
        }

        li li > a {
            padding-left: 60px;
        }

        li li li > a {
            padding-left: 90px;
        }
    }

    > a {
        display: flex;
        align-items: center;
        padding-right: 0;
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;

        &:active {
            .icon {
                filter: brightness(0) invert(1);
            }
        }
    }

    .icon {
        display: none;
        position: absolute;
        right: 0;
        width: 10px;
        height: 10px;
        align-items: center;
        justify-content: center;
        transform: rotate(-90deg);
        margin-right: 3px;
        fill: $sherpa-blue;
    }
}
</style>
